<template>
  <InputSchool
    label="Intended High School"
    :loading="secondarySchoolLoading"
    :name="props.name"
    :schools="secondarySchoolOptions"
    @search="onSearchSecondarySchools"
  />
</template>

<script setup lang="ts">
import { GetSchoolsSortedDocument } from '@/graphql'

import type { PaginatedDocs } from 'payload/database'
import type { School } from '#payload/types'

interface InputPrimarySchoolProps {
  name: string
}

const props = defineProps<InputPrimarySchoolProps>()

interface SchoolsSortedQuery {
  SchoolsSorted: PaginatedDocs<School>
}

const secondarySchoolQuery = ref('')
const { result: secondarySchoolResult, loading: secondarySchoolLoading } =
  useQuery<SchoolsSortedQuery>(
    GetSchoolsSortedDocument,
    () => ({
      query: secondarySchoolQuery.value,
      type: ['secondary', 'combined', 'special'],
      limit: 50,
    }),
    () => ({
      debounce: 250,
      fetchPolicy: 'no-cache',
    }),
  )

const secondarySchoolOptions = computed(() => {
  return secondarySchoolResult.value?.SchoolsSorted.docs || []
})

const onSearchSecondarySchools = (search: string) => {
  secondarySchoolQuery.value = search
}
</script>
